<template>
  <Modal id="feedback-add" modifier="testimonial" #default="{ close }">
    <div class="close" @click="close">
      <SvgIcon name="close" />
    </div>

    <h2>Add your feedback</h2>

    <ValidationObserver ref="form" v-slot="{}" tag="form" class="form" @submit.prevent="handleSubmit(close)">
      <ValidationProvider v-slot="{ errors }" class="ui-group" rules="max:1500|required">
        <Input
          :value="comment"
          textarea
          :placeholder="$t('ModalFeedbackAddPlaceholder')"
          :error="errors[0]"
          rows="9"
          maxlength="1500"
          @onChange="(v) => (comment = v)"
        />
      </ValidationProvider>

      <div class="form__cta">
        <button type="button" class="gray large" @click="resetState">{{ $t('clearAll') }}</button>
        <button type="submit" class="blue large">{{ $t('submit') }}</button>
      </div>
    </ValidationObserver>
  </Modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import { withUi } from '@/components/ui'
import Modal from '@/components/modals/Modal'

export default {
  name: 'ModalFeedbackAdd',
  components: { Modal },
  mixins: [withUi],
  data() {
    return {
      comment: '',
    }
  },
  methods: {
    resetState() {
      this.comment = ''
    },
    async handleSubmit(close) {
      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return
      }

      this.addFeedback({
        data: {
          content: this.comment,
        },
      }).then(() => {
        this.resetState()
        this.getFeedback()
        close()
        this.openModal('feedback-added')
      })
    },
    ...mapMutations(['openModal', 'closeModal']),
    ...mapActions('feedback', ['addFeedback', 'getFeedback']),
  },
}
</script>

<style lang="scss">
#modal-feedback-add {
  .close {
    position: absolute;
    z-index: 3;
    top: 20px;
    right: 10px;
    color: $dark;
    font-size: 0;
    padding: 10px;
    cursor: pointer;
    transition: color 0.25s $ease;
    .svg-icon {
      font-size: 14px;
    }
    &:hover {
      color: $primary;
    }
  }
  h2 {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 26px;
    text-align: left;
    @media (max-width: 480px) {
      font-size: 20px;
      margin-bottom: 24px;
    }
  }

  .form {
    &__cta {
      margin-top: 28px;
      display: flex;
      justify-content: flex-end;
      button {
        margin-right: 10px;
        min-width: 99px;
        &:last-child {
          margin-right: 0;
        }
      }
      @media (max-width: 480px) {
        margin-top: 24px;
        button {
          width: 50%;
        }
      }
    }
  }
}
</style>
